import { RouteObject } from "react-router";

import { Navigate } from "react-router-dom";

import BaseLayout from "../layouts/BaseLayout";
import baseRoutes from "./base";
import React, { lazy } from "react";
import AccentHeaderLayout from "../core/AccentHeaderLayout";
import BottomNavigationLayout from "../core/BottomNavigationLayout";
import PatientDashboard from "../content/Dashboards/PacientDashboard/PatientDashboard";
import FeedbackForm from "../content/forms/Feedback/FeedbackForm";
import ShoppingCart from "../content/pages/ShoppingCart/ShoppingCart";
import Calendar from "../content/pages/ShoppingCart/Calendar";
import PatientArchive from "../content/Dashboards/PacientDashboard/PatientArchive/PatientArchive";
import TermsAndConditions from "../content/pages/Terms/Terms";
const router: RouteObject[] = [
  {
    path: "",
    element: <BaseLayout />,
    children: baseRoutes,
  },
  // Documentation
  // Boxed Sidebar Layout

  // Accent Sidebar Layout

  {
    path: "accent-header",
    element: (
      // <Authenticated>
      <AccentHeaderLayout />
      // </Authenticated>
    ),
    children: [
      {
        path: "",
        element: <Navigate to="dashboards" replace />,
      },
    ],
  },

  {
    path: "",
    element: (
      // <Authenticated>
      <BottomNavigationLayout />
      // </Authenticated>
    ),
    children: [
      {
        path: "patient-dashboard",
        element: <PatientDashboard />,
      },
      {
        path: "patient-archive",
        element: <PatientArchive />,
      },
      // {
      //   path: "portalmanager-dashboard",
      //   element: <PortalManagerDashboard />,
      // },
      {
        path: "feedback",
        element: <FeedbackForm />,
      },
      {
        path:"shoppingcart/:shoppingCartIdentity",
        element:<ShoppingCart/>
      },
      {
        path:"terms-of-service",
        element:<TermsAndConditions/>
      },
      {
        path:"calendar",
        element:<Calendar/>
      }
    ],
  },

  // Extended Sidebar Layout
];

export default router;
